import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import FadeInSection from '../../../components/feature/FadeInSection';
import { supabase } from '../../../lib/supabaseClient';
import { SuccessCase } from '../../../types/successCase';

export default function SuccessPickupSection() {
  const [cases, setCases] = useState<SuccessCase[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCases = async () => {
      const { data } = await supabase
        .from('8a4f04ed_success_cases')
        .select('*')
        .eq('published', true)
        .order('sort_order', { ascending: true })
        .limit(4);
      if (data) setCases(data as SuccessCase[]);
      setLoading(false);
    };
    fetchCases();
  }, []);

  return (
    <section className="section-padding" style={{ background: '#f2f8f4' }}>
      <div className="content-width">
        <FadeInSection className="text-center mb-8 md:mb-14">
          <p
            className="inline-block px-4 py-1 rounded-full mb-4 text-sm font-bold"
            style={{ background: '#5a9e6f', color: '#fff' }}
          >
            成婚事例
          </p>
          <h2 style={{ color: '#4a3728' }}>成婚実績</h2>
          <p style={{ color: '#6b5a4e', marginTop: '12px', fontSize: '17px' }}>
            50代・60代・70代の方の成婚実績が豊富です
          </p>
        </FadeInSection>

        {loading ? (
          <div className="flex items-center justify-center py-16 gap-3" style={{ color: '#9b8b7f' }}>
            <span className="flex items-center justify-center w-5 h-5">
              <i className="ri-loader-4-line text-xl animate-spin" style={{ color: '#5a9e6f' }}></i>
            </span>
            読み込み中...
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-8 md:mb-12">
            {cases.map((item, index) => (
              <FadeInSection key={item.id} delay={index * 100}>
                <article className="card-base overflow-hidden cursor-pointer" style={{ padding: '0' }}>
                  {item.image_url && (
                    <div className="w-full h-[160px] md:h-[200px] overflow-hidden">
                      <img
                        src={item.image_url}
                        alt={`${item.ages}の成婚事例 - シニアカップルの幸せな写真`}
                        className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                        loading="lazy"
                        decoding="async"
                        width={480}
                        height={200}
                      />
                    </div>
                  )}
                  <div className="p-4 md:p-8">
                    {item.active_period && (
                      <span
                        className="inline-block px-3 py-1 rounded-full text-xs md:text-sm font-bold mb-2 md:mb-3"
                        style={{ background: '#f2f8f4', color: '#5a9e6f', border: '1px solid #5a9e6f' }}
                      >
                        {item.active_period}
                      </span>
                    )}
                    <h3 style={{ color: '#8b4513', fontSize: 'clamp(16px, 2.5vw, 22px)', marginBottom: '8px' }}>
                      {item.ages}
                    </h3>
                    <p style={{ color: '#6b5a4e', lineHeight: '1.8', fontSize: 'clamp(13px, 1.8vw, 15px)' }}>
                      {item.excerpt}
                    </p>
                  </div>
                </article>
              </FadeInSection>
            ))}
          </div>
        )}

        <FadeInSection className="text-center">
          <Link to="/success" className="btn-secondary inline-flex items-center gap-2">
            成婚事例をもっと見る
            <span className="flex items-center justify-center w-5 h-5">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </FadeInSection>
      </div>
    </section>
  );
}